<template>
    <div class="flex justify-between items-center px-3 md:px-4 lg:px-8 py-3 border-b border-gray mb-3 md:mb-6">
        <h1><slot name="title"></slot></h1>

        <div class="flex gap-x-4">
            <slot name="actions"></slot>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>